export default "__VITE_ASSET__ebU3vVmF__"